import { getJson, postJson } from "../../../../core/utils/http";

export type DatosConfiguracion = {
	nombreCorto: string;
	nombre: string;
	colorBanner: string;
	colorFondoPantalla: string;
	colorLetraPantalla: string;
	colorFondoMenu: string;
	colorLetraMenu: string;
	colorFondoMenuTabla: string;
	colorLetraMenuTabla: string;
	colorFondoRegistro: string;
	colorLetraRegistro: string;
	colorFondoBotonPrimario: string;
	colorLetraBotonSecundario: string;
	colorFondoBotonSecundario: string;
	colorLetraBotonPrimario: string;
};

type obtenerInicialesHandler = (segmentoRuteo: string, usuario: string) => Promise<string>;

type enviarCodigoHandler = (segmentoRuteo: string, usuario: string, telefono: string) => Promise<void>;

type registrarCuentaHandler = (segmentoRuteo: string, usuario: string, clave: string, codigoOtp: string) => Promise<void>;

type restablecerClaveHandler = (segmentoRuteo: string, usuario: string, clave: string, codigoOtp: string) => Promise<void>;

type obtenerConfiguracionHandler = (segmentoRuteo: string) => Promise<DatosConfiguracion>;

export const obtenerIniciales: obtenerInicialesHandler = (segmentoRuteo: string, usuario: string) =>
	postJson("/Usuarios/Iniciales", { segmentoRuteo, usuario });

export const enviarCodigo: enviarCodigoHandler = (segmentoRuteo: string, usuario: string, telefono: string) =>
	postJson("/Usuarios/CodigoOtp", { segmentoRuteo, usuario, telefono });

export const registrarCuenta: registrarCuentaHandler = (segmentoRuteo: string, usuario: string, clave: string, codigoOtp: string) =>
	postJson("/Usuarios", { segmentoRuteo, usuario, clave, codigoOtp });

export const restablecerClave: restablecerClaveHandler = (segmentoRuteo: string, usuario: string, nuevaClave: string, codigoOtp: string) =>
	postJson("/Usuarios/Clave:restablecer", { segmentoRuteo, usuario, nuevaClave, codigoOtp });

export const obtenerConfiguracion: obtenerConfiguracionHandler = (segmentoRuteo: string) =>
	getJson(`/Usuarios/Configuracion/${segmentoRuteo}`);

// BOrrar
export const validarCodigo = (segmentoRuteo: string, usuario: string, telefono: string, codigoOtp: string) =>
	postJson("/Usuarios/CodigoOtp:validar", { segmentoRuteo, usuario, telefono, codigoOtp });
